import { formatDate } from "utils/formatDate";
import ToolTip from "components/design/toolTip";
import { Tag } from "components/DesignSystem/Tag/Tag";

export const TaskDeadlineInfo = ({
  deadline,
  latestDeadlineUpdate,
}: {
  deadline: string | null;
  latestDeadlineUpdate?: {
    owner: { name: string };
    event: { time: string };
  } | null;
}) => {
  if (!deadline) {
    return <>-</>;
  }

  return (
    <div className="t-flex t-gap-1 t-items-center">
      {formatDate(deadline)}
      {latestDeadlineUpdate && (
        <ToolTip
          text={
            <div className="t-w-28">
              Edited by <b>{latestDeadlineUpdate.owner.name}</b> on{" "}
              <b>{formatDate(latestDeadlineUpdate.event.time)}</b>
            </div>
          }
        >
          <span>
            <Tag tagType="gray" icon={false} rounded size="small">
              Edited
            </Tag>
          </span>
        </ToolTip>
      )}
    </div>
  );
};
